const translation = {
  'apply.seo.title': 'Apply for a Spanish Course with Iberia Language Academy',
  'apply.seo.description': `Book your Spanish course today and take the first step towards Spanish fluency in Barcelona`,

  'apply.sec1.title': `Complete our simple, non-committal application form and we’ll get back to you in under
  12 hours`,

  'apply.step1.title': `Step 1`,
  'apply.step1.text': `Application`,

  'apply.step2.title': `Step 2`,
  'apply.step2.text': `Language awareness task`,

  'apply.step3.title': `Step 3`,
  'apply.step3.text': `Interview`,

  'apply.step4.title': `Step 4`,
  'apply.step4.text': `Place offer`,

  'apply.form.title': `The Course`,
  'apply.form.subTitle1': `Which course would you like to attend?*`,
  'apply.form.course.option1': `Barcelona Trinity CertTESOL`,
  'apply.form.course.option2': `Seville Trinity CertTESOL`,
  'apply.form.course.option3': `Developing Teacher course only`,
  'apply.form.course.option4': `Developing Teacher & Spanish course only`,
  'apply.form.course.option5': `Not sure`,

  'apply.form.subTitle2': `Start date*`,
  'apply.form.prefferedCourseDate': `Select your preferred course date`,
  'apply.form.date.option1': `July 3th, 2023`,
  'apply.form.date.option2': `July 31th, 2023`,
  'apply.form.date.option3': `September 4th, 2023`,

  'apply.form.subTitle3': ` Would you like an extension course to apply for a student visa?`,
  'apply.form.extension.option1': `Developing Teacher`,
  'apply.form.extension.option2': `Developing Teacher & Spanish`,
  'apply.form.extension.option3': `Not sure`,

  'apply.form.title2': `About you`,
  'apply.form.about.firstName': `First Name*`,
  'apply.form.about.lastName': `Last Name*`,
  'apply.form.about.email': `Email address*`,
  'apply.form.about.phone': `Phone Number`,
  'apply.form.about.userLocation': `Your current location*`,
  'apply.form.about.userLocation.placeholder': `e.g. London, UK`,
  'apply.form.about.nativeSpeaker': `Are you a native English speaker?*`,
  'apply.form.about.nativeSpeaker.yes': `Yes`,
  'apply.form.about.nativeSpeaker.no': `No`,
  'apply.form.about.nationality': `Nationality*`,
  'apply.form.about.nationality.placeholder': `Select your country`,
  'apply.form.about.dateOfBirth': `Date of birth*`,
  'apply.form.about.dateOfBirth.dd': `DD`,
  'apply.form.about.dateOfBirth.mm': `MM`,
  'apply.form.about.dateOfBirth.yyyy': `YYYY`,

  'apply.form.subTitle4': `Additional Services`,
  'apply.form.service.title': `  Do you require any additional services? Please select all the apply:`,
  'apply.form.service.accommodation': `Accommodation`,
  'apply.form.service.airportPickUp': `Airport Pickup`,
  'apply.form.service.nieTie': `TIE / NIE Appointment and Assistance`,
  'apply.form.service.culturalActivities': `Cultural activity`,
  'apply.form.service.promotionalCode': `Promotional code`,
  'apply.form.service.promotionalCode.placeholder': `Enter code`,
  'apply.form.service.comments': `Comments / Questions`,
  'apply.form.service.comments.placeholder': `Any comments or questions? Write here.`,
  'apply.form.service.termsTitle': `Terms and conditions*`,
  'apply.form.service.terms': ` I agree to TEFL Iberia’s
  <a1>
    terms and conditions
  </a1>
  and
  <a2>
    privacy policy.
  </a2>`,

  'apply.form.btn.submit': `Submit application`,
};
export default translation;
